import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Tooltip } from '@telus-uds/components-web';
import Edit from '@telus-uds/palette-allium/build/web/icons/Edit';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { ConfirmationContainer, ConfirmationMessage } from './css';
import getFormattedPrice from '../util';

const ServiceListRow = ({ rowData, setEditService, removeService, index }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      deleteButtonLabel,
      cancelButtonLabel,
      editButtonLabel,
      confirmButtonLabel
    },
    callCentre: {
      deleteConfirmationText,
      tableHeader: { labelServiceName, labelPrice, labelQuantity }
    }
  } = localizedStrings;

  const { id, name, price, quantity } = rowData;
  const [isDelete, setIsDelete] = useState(false);
  return (
    <>
      {isDelete ? (
        <tr>
          <td colSpan="6">
            <ConfirmationContainer>
              <ConfirmationMessage>
                {deleteConfirmationText}
              </ConfirmationMessage>
              <Button onPress={() => removeService(id)}>
                {confirmButtonLabel}
              </Button>
              <Button
                variant={{ priority: 'low' }}
                onPress={() => {
                  setIsDelete(false);
                }}
              >
                {cancelButtonLabel}
              </Button>
            </ConfirmationContainer>
          </td>
        </tr>
      ) : (
        <tr>
          <td width="10%" data-header-label="#">{index + 1}</td>
          <td width="50%" data-header-label={labelServiceName}>{name}</td>
          <td width="15%" data-header-label={labelPrice}>{getFormattedPrice(price)}</td>
          <td width="10%" data-header-label={labelQuantity}>{quantity}</td>
          <td width="20%">
            <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
              <Tooltip content={editButtonLabel}>
                <Button
                  icon={Edit}
                  accessibilityLabel={editButtonLabel}
                  onPress={() => setEditService(id)}
                  variant={{ text: true }}
                />
              </Tooltip>
              <Tooltip content={deleteButtonLabel}>
                <Button
                  icon={Delete}
                  accessibilityLabel={deleteButtonLabel}
                  onPress={() => setIsDelete(true)}
                  variant={{ text: true }}
                />
              </Tooltip>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

ServiceListRow.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.any).isRequired,
  setEditService: PropTypes.func.isRequired,
  removeService: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default ServiceListRow;
